<template>
  <v-main class="bg" :style="`background-image: url('${fondoURL}');`">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col class="d-flex justify-space-around" cols="12">
          <transition name="slide-fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
      v-model="getAlerta.visible"
      :color="getAlerta.color"
      :timeout="getAlerta.tiempo"
    >
      {{ getAlerta.mensaje }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="hideAlerta">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Inicio",
  data() {
    return {
      fondoURL:
        process.env.VUE_APP_BASE_PATH + `/api/config/GetImagen?id=inicio`
    };
  },
  methods: {
    ...mapActions(["hideAlerta"])
  },
  computed: {
    ...mapGetters(["getAlerta"])
  }
};
</script>

<style scoped>
.bg {
  background-size: contain;
  background-position: center;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
